import React from 'react';

const Footer = () => (
    <footer className="my-5 pt-5 text-muted text-center text-small">
        <p className="mb-1">© 2017-2018 Company Name</p>
        <ul className="list-inline">
            <li className="list-inline-item"><a href="#privacy">Privacy</a></li>
            <li className="list-inline-item"><a href="#terms">Terms</a></li>
            <li className="list-inline-item"><a href="#support">Support</a></li>
        </ul>
    </footer>
)

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js